/**
 * AdminButton — small icon button next to the theme toggle that opens the
 * admin nav panel (specs/open/feedback-submissions-management.md §9.1).
 * Rendered by the caller only after GET /whoami confirms isAdmin -- this
 * component itself does no gating, matching RoadmapButton/FeedbackButton's
 * presentational-only convention (the caller owns when/whether to render
 * it, this just renders the button and reports clicks).
 *
 * Relocated from the sidebar (v1) to sit beside the theme toggle (v2, §9.1)
 * -- a small icon button here, not the full-width sidebar button v1 used,
 * since this is now an entry point into a 3-tab panel rather than a single
 * feedback list.
 */
import React from 'react';
import { ThemeColors } from './useTheme';

interface AdminButtonProps {
  colors: ThemeColors;
  /** Invoked on click; the caller wires this to open AdminPanel. */
  onOpen: () => void;
}

/** Renders the admin panel entry point, styled to sit inline with the theme toggle row. */
export function AdminButton({ colors, onOpen }: AdminButtonProps): React.ReactElement {
  const buttonStyle: React.CSSProperties = {
    background: 'transparent',
    border: `1px solid ${colors.border}`,
    borderRadius: '4px',
    color: colors.textMuted,
    cursor: 'pointer',
    fontSize: '14px',
    padding: '4px 8px',
    lineHeight: 1,
  };

  return (
    <button onClick={onOpen} style={buttonStyle} title="Admin panel">
      🔧
    </button>
  );
}
